import React from 'react';
import osBg from '../../assets/images/os-bg.png';
import osHin from '../../assets/images/os-hin.png';
import osLeft from '../../assets/images/os-left.png';
import osF1 from '../../assets/images/os-f1.png';
import osF2 from '../../assets/images/os-f2.png';
import osF3 from '../../assets/images/os-f3.png';
import osF4 from '../../assets/images/os-f4.png';
import osHat from '../../assets/images/os-hat.png';

const ORDER_LINK = 'https://grill-me-crazy-indo-mexican-alice-springs.nextorder.com/';

const circles = [
  { img: osF1, bg: '#AB122A', label: 'INDIA', sub: 'The Spice' },
  { img: osF2, bg: '#FFC600', label: 'FUSION', sub: 'The Chaos' },
  { img: osF3, bg: '#0B5026', label: 'MEXICO', sub: 'The Fiesta' },
  { img: osF4, bg: '#000000', label: 'US', sub: 'The Crazy' },
];

const OurStory: React.FC = () => {
  return (
    <section id="our-story" className="w-full relative mt-52 mb-20" style={{ background: '#FFF2DA', overflow: 'visible' }}>

      {/* ===== MOBILE (below md) ===== */}
      <div
        className="md:hidden relative w-full"
        style={{
          backgroundImage: `url(${osBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          overflow: 'visible',
        }}
      >
        {/* os-hat.png - Mobile, overlaps outside */}
        <img
          src={osHat}
          alt="Sombrero"
          className="absolute pointer-events-none"
          style={{ width: '180px', height: 'auto', bottom: '-60px', right: '10px', zIndex: 30 }}
        />

        <div className="flex flex-col items-center text-center px-6 py-12">
          <div
            className="flex items-center justify-center mb-4"
            style={{ backgroundColor: '#FFC600', borderRadius: '50px', padding: '5px 20px' }}
          >
            <span className="font-teko leading-none" style={{ fontSize: '15px', color: '#151515', fontWeight: 400 }}>
              TWO CULTURES - ONE RESTAURANT
            </span>
          </div>

          <h2 className="font-teko font-medium leading-none mb-0" style={{ fontSize: '42px', color: '#FFF2DA' }}>
            WHY CHOOSE
          </h2>
          <h2 className="font-teko font-medium leading-none" style={{ fontSize: '42px' }}>
            <span style={{ color: '#FFC600' }}>ONE </span>
            <span style={{ color: '#FFF2DA' }}>CULTURE</span>
          </h2>

          <div className="mt-4 max-w-sm">
            <p className="mb-2" style={{ color: '#FFF2DA', fontSize: '13px', lineHeight: '1.6', fontFamily: "'Satoshi', sans-serif", fontWeight: 400 }}>
              We didn't set out to create a fusion restaurant. We set out to create a feeling, the chaos of a India, the colour of a Day of the Dead festival in Oaxaca, and the unapologetic boldness of Alice Springs hospitality.
            </p>
            <p style={{ color: '#FFF2DA', fontSize: '13px', lineHeight: '1.6', fontFamily: "'Satoshi', sans-serif", fontWeight: 400 }}>
              Grill Me Crazy is what happens when you stop following rules. India brought the spice, the tandoor, the depth. Mexico brought the fiesta, the freshness, the heat. We brought them together and Alice Springs went crazy for it.
            </p>
          </div>

          <div className="flex items-start mt-5 justify-center" style={{ gap: '0' }}>
            {circles.map((item, index) => (
              <div key={index} className="flex flex-col items-center relative px-2 flex-shrink-0">
                {index > 0 && (
                  <div className="absolute" style={{ top: '24px', right: '70%', width: '22px', height: '2px', backgroundColor: '#FFFFFF' }} />
                )}
                <div
                  className="flex items-center justify-center overflow-hidden z-10"
                  style={{ width: '42px', height: '42px', borderRadius: '50%', backgroundColor: item.bg }}
                >
                  <img src={item.img} alt={item.label} className="h-full w-full object-scale-down" />
                </div>
                <span className="font-teko mt-1 text-center block" style={{ fontSize: '18px', color: '#FFF2DA', fontWeight: 400 }}>
                  {item.label}
                </span>
                <span className="text-center block" style={{ fontSize: '10px', color: '#FFFFFF', fontFamily: "'Satoshi', sans-serif", fontWeight: 400 }}>
                  {item.sub}
                </span>
              </div>
            ))}
          </div>

          <div className="mt-5">
            <div style={{ boxShadow: '0 4px 0 0 #151515', borderRadius: '8px', display: 'inline-block' }}>
              <a
                href={ORDER_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="font-teko font-normal text-black transition-all duration-200 hover:translate-y-[4px] hover:bg-yellow-400"
                style={{ backgroundColor: '#FFC600', border: '1px solid #151515', borderRadius: '8px', color: '#000000', fontSize: '16px', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', cursor: 'pointer', padding: '8px 28px' }}
              >
                RESERVE A TABLE
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* ===== DESKTOP (md and above) — RESPONSIVE ===== */}
      <div className="hidden md:block relative w-full mx-auto" style={{ maxWidth: '1920px', overflow: 'visible' }}>
        <style>{`
          .os-story-container { height: 904px; overflow: hidden; }
          .os-heading { font-size: 98px; }
          .os-hin { width: 480px; top: -70px; right: 10px; z-index: 30; }
          .os-left-img { width: 600px; height: 1100px; left: 25%; top: 50%; transform: translate(-50%, -50%); object-fit: contain; z-index: 30; }
          .os-hat { width: 420px; height: 213px; bottom: -117px; z-index: 30; }
          .os-label { width: 341.4px; height: 34px; }
          .os-label-text { font-size: 25px; }
          .os-circle { width: 64px; height: 64px; }
          .os-circle-label { font-size: 30px; }
          .os-btn { width: 194px; height: 44px; font-size: 18px; }
          .os-circle-line { top: 32px; width: 44px; }
          .os-right-content { right: clamp(20px, 2vw, 60px); width: clamp(280px, 45vw, 650px); }
          .os-para { font-size: 15px; }

          /* Laptop */
          @media (min-width: 992px) and (max-width: 1199px) {
            .os-story-container { height: 700px; }
            .os-heading { font-size: 68px; }
            .os-hin { width: 320px; top: -50px; right: 8px; }
            .os-left-img { width: 380px; height: 120%; left: 22%; }
            .os-hat { width: 360px; height: 142px; bottom: -80px; right: 12px; }
            .os-label { width: 240px; height: 28px; }
            .os-label-text { font-size: 18px; }
            .os-circle { width: 50px; height: 50px; }
            .os-circle-label { font-size: 22px; }
            .os-btn { width: 160px; height: 38px; font-size: 16px; }
            .os-circle-line { top: 25px; width: 34px; }
            .os-right-content { right: 20px; width: clamp(240px, 42vw, 500px); }
            .os-para { font-size: 13px; }
            .os-para-line { line-height: 1.5; }
          }

          /* Tablet */
          @media (min-width: 768px) and (max-width: 991px) {
            .os-story-container { height: 500px; }
            .os-heading { font-size: 52px; }
            .os-hin { width: 220px; top: -35px; right: 5px; }
            .os-left-img { width: 240px; height: 85%; left: 25%; }
            .os-hat { width: 200px; height: 92px; bottom: -55px; right: 8px; }
            .os-label { width: 180px; height: 24px; }
            .os-label-text { font-size: 14px; }
            .os-circle { width: 42px; height: 42px; }
            .os-circle-label { font-size: 18px; }
            .os-btn { width: 140px; height: 34px; font-size: 14px; }
            .os-circle-line { top: 21px; width: 26px; }
            .os-right-content { right: 15px; width: clamp(200px, 40vw, 400px); }
            .os-para { font-size: 12px; }
            .os-para-line { line-height: 1.4; }
          }

          /* Desktop */
          @media (min-width: 1200px) and (max-width: 1439px) {
            .os-story-container { height: 904px; }
            .os-heading { font-size: 98px; }
            .os-hin { width: 480px; top: -70px; right: 10px; }
            .os-left-img { width: 600px; height: 1100px; left: 25%; top: 50%; transform: translate(-50%, -50%); object-fit: contain; }
            .os-hat { width: 420px; height: 213px; bottom: -117px; right: 18px; }
            .os-label { width: 341.4px; height: 34px; }
            .os-label-text { font-size: 25px; }
            .os-circle { width: 64px; height: 64px; }
            .os-circle-label { font-size: 30px; }
            .os-btn { width: 194px; height: 44px; font-size: 18px; }
            .os-circle-line { top: 32px; width: 44px; }
            .os-right-content { right: clamp(20px, 2vw, 60px); width: clamp(280px, 45vw, 650px); }
            .os-para { font-size: 15px; }
          }

          /* Large Desktop */
          @media (min-width: 1440px) {
            .os-story-container { height: 904px; }
            .os-heading { font-size: 98px; }
            .os-hin { width: 480px; top: -70px; right: 10px; }
            .os-left-img { width: 700px; height: 1200px; left: 25%; top: 50%; transform: translate(-50%, -50%); object-fit: contain; }
            .os-hat { width: 420px; height: 213px; bottom: -117px; right: 18px; }
            .os-label { width: 341.4px; height: 34px; }
            .os-label-text { font-size: 25px; }
            .os-circle { width: 64px; height: 64px; }
            .os-circle-label { font-size: 30px; }
            .os-btn { width: 194px; height: 44px; font-size: 18px; }
            .os-circle-line { top: 32px; width: 44px; }
            .os-right-content { right: clamp(20px, 2vw, 60px); width: clamp(280px, 45vw, 650px); }
            .os-para { font-size: 15px; }
          }
        `}</style>

        {/* os-hin.png - OUTSIDE container, will show above */}
        <img
          src={osHin}
          alt="Decorative"
          className="absolute pointer-events-none os-hin"
          style={{ height: 'auto' }}
        />

        {/* os-left.png - OUTSIDE container, edges extend beyond bg */}
        <img
          src={osLeft}
          alt="Our Kitchen"
          className="absolute pointer-events-none os-left-img"
        />

        {/* os-hat.png - OUTSIDE container, will show below */}
        <img
          src={osHat}
          alt="Sombrero"
          className="absolute pointer-events-none os-hat"
        />

        {/* Main Background Image Container - overflow hidden to hide scrollbar */}
        <div className="relative w-full os-story-container" style={{ maxWidth: '1920px' }}>
          <img
            src={osBg}
            alt="Our Story Background"
            className="w-full h-full object-cover"
          />

          {/* Right Side Content */}
          <div
            className="absolute flex flex-col justify-center os-right-content"
            style={{ top: '50%', transform: 'translateY(-50%)' }}
          >
            {/* Label */}
            <div
              className="flex items-center justify-center mb-6 os-label"
              style={{ backgroundColor: '#FFC600', borderRadius: '50px' }}
            >
              <span className="font-teko items-center text-center block leading-none os-label-text" style={{ color: '#151515', fontWeight: 400 }}>
                TWO CULTURES - ONE RESTAURANT
              </span>
            </div>

            {/* Heading */}
            <div className="text-left">
              <h2 className="font-teko font-medium leading-none mb-0 os-heading" style={{ color: '#FFF2DA' }}>
                WHY CHOOSE
              </h2>
              <h2 className="font-teko font-medium leading-none os-heading">
                <span style={{ color: '#FFC600' }}>ONE </span>
                <span style={{ color: '#FFF2DA' }}>CULTURE</span>
              </h2>
            </div>

            {/* Paragraphs */}
            <div className="text-left mt-6">
              <p className="mb-4 os-para os-para-line" style={{ color: '#FFF2DA', fontFamily: "'Satoshi', sans-serif", fontWeight: 400, lineHeight: '1.7' }}>
                We didn't set out to create a fusion restaurant. We set out to create a feeling, the chaos of a India, the colour of a Day of the Dead festival in Oaxaca, and the unapologetic boldness of Alice Springs hospitality.
              </p>
              <p className="os-para os-para-line" style={{ color: '#FFF2DA', fontFamily: "'Satoshi', sans-serif", fontWeight: 400, lineHeight: '1.7' }}>
                Grill Me Crazy is what happens when you stop following rules. India brought the spice, the tandoor, the depth. Mexico brought the fiesta, the freshness, the heat. We brought them together and Alice Springs went crazy for it.
              </p>
            </div>

            {/* Connected Circles */}
            <div className="flex items-start mt-10" style={{ gap: '0' }}>
              {circles.map((item, index) => (
                <div key={index} className="flex flex-col items-center relative px-5">
                  {index > 0 && (
                    <div className="absolute os-circle-line" style={{ right: '80%', height: '2px', backgroundColor: '#FFFFFF' }} />
                  )}
                  <div
                    className="flex items-center justify-center overflow-hidden z-10 os-circle"
                    style={{ borderRadius: '50%', backgroundColor: item.bg }}
                  >
                    <img src={item.img} alt={item.label} className="h-full w-full object-scale-down" />
                  </div>
                  <span className="font-teko mt-2 text-center block os-circle-label" style={{ color: '#FFF2DA', fontWeight: 400 }}>
                    {item.label}
                  </span>
                  <span className="text-center block" style={{ fontSize: '14px', color: '#FFFFFF', fontFamily: "'Satoshi', sans-serif", fontWeight: 400 }}>
                    {item.sub}
                  </span>
                </div>
              ))}
            </div>

            {/* Reserve A Table Button */}
            <div className="mt-8">
              <div style={{ boxShadow: '0 4px 0 0 #151515', borderRadius: '8px', display: 'inline-block' }}>
                <a
                  href={ORDER_LINK}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-teko font-normal text-black transition-all duration-200 hover:translate-y-[4px] hover:bg-yellow-400 os-btn"
                  style={{ backgroundColor: '#FFC600', border: '1px solid #151515', borderRadius: '8px', color: '#000000', fontWeight: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', textDecoration: 'none', cursor: 'pointer' }}
                >
                  RESERVE A TABLE
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
